'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeMinorTicks = exports.computeTimeTicks = exports.computeTimeDomain = exports.computeTimeSteps = exports.computeTimeMinorStep = exports.getTimeMajorStep = exports.getTimeDefaultMajorStep = exports.getTimeDomainDelta = exports.getMinLabelWidth = undefined;
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getMinLabelWidth = exports.getMinLabelWidth = function getMinLabelWidth(_ref) {
  var domain = _ref.domain,
    options = _ref.options;
  var proc = R.path(['format', 'proc'], options);
  var labelFormat = R.is(Function, proc) ? proc : _d2.default.time.format(R.path(['format', 'pattern'], options));
  var fontSize = R.pathOr(12, ['font', 'size'], options);
  var charWidth = Math.ceil(fontSize * 0.5);
  var label = labelFormat(R.head(domain));
  if (R.isNil(label)) {
    return 30; //security;
  }
  return (R.length(label) + 3) * charWidth;
};
var getTimeDomainDelta = exports.getTimeDomainDelta = function getTimeDomainDelta(_ref2) {
  var domain = _ref2.domain,
    frequency = _ref2.frequency,
    step = _ref2.step;
  var _R$sortBy = R.sortBy(function (date) {
      return Date.parse(date);
    }, domain),
    _R$sortBy2 = (0, _slicedToArray3.default)(_R$sortBy, 2),
    min = _R$sortBy2[0],
    max = _R$sortBy2[1];
  var parsedMax = Date.parse(max);
  var freq = R.has(frequency, _d2.default.time) ? frequency : 'year';
  return R.until(function (offset) {
    var date = _d2.default.time[freq].utc.offset(min, offset);
    var parsed = Date.parse(date);
    return parsed >= parsedMax;
  }, R.add(step))(step);
};
var getTimeDefaultMajorStep = exports.getTimeDefaultMajorStep = function getTimeDefaultMajorStep(_ref3) {
  var labelSize = _ref3.labelSize,
    rangeDelta = _ref3.rangeDelta,
    domainDelta = _ref3.domainDelta,
    options = _ref3.options;
  var dataStep = R.pathOr('year', ['linear', 'step'], options);
  var maxSlices = R.when(R.equals(0), R.always(1))(Math.floor(rangeDelta / labelSize));
  var minStep = Math.ceil(domainDelta / maxSlices);
  if (dataStep >= minStep) {
    return dataStep;
  }
  var frequency = R.pathOr('year', ['linear', 'frequency'], options);
  var stepValidator = function stepValidator(step) {
    if (frequency !== 'month') {
      return true;
    }
    return step < 12 ? 12 % step === 0 : step % 12 === 0;
  };
  return R.until(stepValidator, R.inc)(minStep);
};
var getTimeMajorStep = exports.getTimeMajorStep = function getTimeMajorStep(_ref4) {
  var labelSize = _ref4.labelSize,
    rangeDelta = _ref4.rangeDelta,
    domainDelta = _ref4.domainDelta,
    options = _ref4.options;
  var defaultStep = getTimeDefaultMajorStep({
    labelSize: labelSize,
    rangeDelta: rangeDelta,
    domainDelta: domainDelta,
    options: options
  });
  var inputStep = R.path(['tick', 'step'], options);
  return inputStep >= defaultStep ? inputStep : defaultStep;
};
var computeTimeMinorStep = exports.computeTimeMinorStep = function computeTimeMinorStep(_ref5) {
  var dataStep = _ref5.dataStep,
    majorStep = _ref5.majorStep,
    rangeDelta = _ref5.rangeDelta,
    domainDelta = _ref5.domainDelta;
  if (dataStep === majorStep) {
    return dataStep;
  }
  var dataSlices = Math.floor(domainDelta / dataStep);
  var dataSliceDelta = Math.floor(rangeDelta / dataSlices);
  if (dataSliceDelta >= 4) {
    return dataStep;
  }
  var maxSlices = Math.floor(rangeDelta / 4);
  var minStep = Math.ceil(domainDelta / maxSlices);
  return R.pipe(R.until(function (step) {
    return majorStep % step === 0;
  }, R.inc))(minStep);
};
var computeTimeSteps = exports.computeTimeSteps = function computeTimeSteps(_ref6) {
  var range = _ref6.range,
    domain = _ref6.domain,
    options = _ref6.options;
  if (R.isNil(domain) || R.isEmpty(domain) || R.any(R.isNil)(domain)) {
    return {
      minorStep: null,
      majorStep: null
    };
  }
  var labelSize = getMinLabelWidth({
    domain: domain,
    options: options
  });
  var rangeDelta = Math.abs(range[1] - range[0]) + 1;
  var _options$linear = options.linear,
    frequency = _options$linear.frequency,
    step = _options$linear.step;
  var domainDelta = getTimeDomainDelta({
    domain: domain,
    frequency: frequency,
    step: step
  });
  var majorStep = getTimeMajorStep({
    labelSize: labelSize,
    rangeDelta: rangeDelta,
    domainDelta: domainDelta,
    options: options
  });
  var minorStep = computeTimeMinorStep({
    dataStep: step,
    rangeDelta: rangeDelta,
    domainDelta: domainDelta,
    majorStep: majorStep
  });
  return {
    majorStep: majorStep,
    minorStep: minorStep
  };
};
var computeTimeDomain = exports.computeTimeDomain = function computeTimeDomain(options, data, datumAccessor, range) {
  var domain = _d2.default.extent(data, datumAccessor);
  if (R.any(R.isNil)(domain)) {
    return [];
  }
  var _options$linear2 = options.linear,
    frequency = _options$linear2.frequency,
    step = _options$linear2.step;
  var domainDelta = getTimeDomainDelta({
    domain: domain,
    frequency: frequency,
    step: step
  });
  var rangeDelta = Math.abs(range[1] - range[0]) + 1;
  var labelSize = getMinLabelWidth({
    domain: domain,
    options: options
  });
  var majorStep = getTimeMajorStep({
    labelSize: labelSize,
    rangeDelta: rangeDelta,
    domainDelta: domainDelta,
    options: options
  });
  var majorDomainDelta = R.until(function (delta) {
    return delta >= domainDelta;
  }, R.add(majorStep))(majorStep);
  var minDomain = R.pipe(R.sortBy(function (date) {
    return Date.parse(date);
  }), R.head)(domain);
  var freq = R.has(frequency, _d2.default.time) ? frequency : 'year';
  var res = [minDomain, _d2.default.time[freq].utc.offset(minDomain, majorDomainDelta)];
  return res;
};
var computeTimeTicks = exports.computeTimeTicks = function computeTimeTicks(_ref7) {
  var domain = _ref7.domain,
    minorStep = _ref7.minorStep,
    options = _ref7.options;
  var frequency = R.pathOr('year', ['linear', 'frequency'], options);
  var freq = R.has(frequency, _d2.default.time) ? frequency : 'year';
  var _R$sortBy3 = R.sortBy(function (date) {
      return Date.parse(date);
    }, domain),
    _R$sortBy4 = (0, _slicedToArray3.default)(_R$sortBy3, 2),
    min = _R$sortBy4[0],
    max = _R$sortBy4[1];
  var ticks = [];
  var tick = min;
  while (Date.parse(tick) <= Date.parse(max)) {
    ticks = R.append(tick, ticks);
    tick = _d2.default.time[freq].utc.offset(tick, minorStep);
  }
  return ticks;
};
var computeMinorTicks = exports.computeMinorTicks = function computeMinorTicks(_ref8) {
  var domain = _ref8.domain,
    minorStep = _ref8.minorStep,
    majorStep = _ref8.majorStep,
    size = _ref8.size,
    options = _ref8.options;

  //size is a trick, giving the amount of minorTicks to avoid too much computation
  var frequency = R.pathOr('year', ['linear', 'frequency'], options);
  var freq = R.has(frequency, _d2.default.time) ? frequency : 'year';
  var min = R.head(R.sortBy(function (date) {
    return Date.parse(date);
  }, domain));
  return R.reduce(function (ticks, index) {
    var step = index * minorStep;
    var tick = _d2.default.time[freq].utc.offset(min, step);
    return R.when(R.always(step % majorStep !== 0), R.append(tick))(ticks);
  }, [], R.times(R.identity, size));
};